






















































import { Vue, Component, Prop, Model } from "vue-property-decorator";
import {
  ProgramPhaseRating,
  ProgramPhaseRatingAttribute,
  ProgramPhaseRatingAttributeNames,
  ProgramQualityRating,
} from "@/data/models/ProgramQualityRating";
import { ProgramChain } from "@/data/models/ProgramChain";
import { floor } from "lodash";
import { isRoomDryingProgram } from "@/data/models/ComBox";
import { COLOR_NOT_SELECTED_QUALITY_RATING, COLOR_SELECTED_QUALITY_RATING } from "@/utils/colors";
import { themedRatingCell } from "@/utils/Theme";

@Component
export default class RateProgramQualityComponent extends Vue {
  @Prop({ default: true })
  editEnabled!: boolean;

  @Prop()
  programChain!: ProgramChain;

  @Prop()
  programNumber!: number;

  @Model("programQualityRating")
  programQualityRating!: ProgramQualityRating;

  ratingOptionsForPhaseChange = [
    "toSlow",
    "ok",
    "toFast",
  ];

  ratingOptions = [
    "toLong",
    "ok",
    "toShort",
  ];

  get phaseRatings(): ProgramPhaseRating {
    return this.programQualityRating.phaseRatings;
  }

  get numPhases() {
    return Object.keys(this.phaseRatings).length;
  }

  programPhaseRatingAttributeNames = ProgramPhaseRatingAttributeNames;

  get phaseRatingHeaderRow() {
    return this.$t("rateDrying.qualityProgram.title");
  }

  getPhaseFromColumnIndex(columnIndex: number) {
    if (columnIndex === 0) {
      return "";
    }

    return Object.keys(this.phaseRatings)[floor((columnIndex - 1) / this.ratingOptionsForPhaseChange.length)];
  }

  toggleProgramQualityRating(
    columnIndex: number,
    rating: ProgramPhaseRatingAttribute
  ) {
    if (!this.canCellBeClicked(columnIndex)) {
      return;
    }
    const selectedOption = (columnIndex - 2);

    const phase = this.getPhaseFromColumnIndex(columnIndex);
    const phaseRatings = this.phaseRatings;
    const currentPhaseRating = 
      phase 
        ? this.phaseRatings[phase]
        : { 
            ["ratings"]: {
              phaseChange: null,
              activity: null,
              pauses: null,
            } 
          };
    
    Object.keys(phaseRatings).forEach((it) => {
      if (it.toString() === phase.toString()) {
        if (currentPhaseRating.ratings[rating] === selectedOption) {
          currentPhaseRating.ratings[rating] = null;
        }
        else {
          currentPhaseRating.ratings[rating] = selectedOption;
        }
      }
    });

    if (Object.keys(phaseRatings).length === 0) {
      if (currentPhaseRating.ratings[rating] === selectedOption) {
        currentPhaseRating.ratings[rating] = null;
      }
      else {
        currentPhaseRating.ratings[rating] = selectedOption;
      }
    }

    const phaseRatingsUpdate = {
      ...this.phaseRatings,
    };

    if (phase) {
      phaseRatingsUpdate[phase] = currentPhaseRating;
    }
    else {
      phaseRatingsUpdate["1"] = currentPhaseRating;
    }
    
    this.$emit("programQualityRating", {
      phaseRatings: phaseRatingsUpdate,
    });
  }

  /** The cell's fill and label class for the active theme (see `themedRatingCell`). */
  ratingCell(lightColor: string) {
    return themedRatingCell(lightColor);
  }

  getProgramQualtityRatingColor(
    columnIndex: number,
    rating: ProgramPhaseRatingAttribute
  ) {
    const phase = this.getPhaseFromColumnIndex(columnIndex);
    const currentRating = phase ? this.phaseRatings[phase].ratings[rating] : null;

    // columnIndex - ratingOptions.length +1
    const selectedOption = (columnIndex - 2);

    if (currentRating === selectedOption) {
      return COLOR_SELECTED_QUALITY_RATING;
    }
    else {
      return COLOR_NOT_SELECTED_QUALITY_RATING;
    }
  }

  canCellBeClicked(index: number) {
    return index > 0;
  }

  getProgramQualtityRow(rating: ProgramPhaseRatingAttribute) {
    const programNumber = this.programNumber;

    if (programNumber && isRoomDryingProgram(programNumber)) {
      if (rating === "phaseChange") {
        return null;
      }
    }

    const labelRes = `${
      rating === "phaseChange"
        ? "phaseChange"
        : rating === "pauses"
        ? "pauses"
        : "activity"
    }`;

    const val = [this.$t(`rateDrying.qualityProgram.${labelRes}`).toString()];
      
    if (labelRes === "phaseChange") {
      this.ratingOptionsForPhaseChange.forEach((ratingOption) => {
        val.push(
          this.$t(
            `rateDrying.qualityProgram.${ratingOption}`
          ).toString()
        )
      });
    }
    else {
      this.ratingOptions.forEach((ratingOption) => {
        val.push(
          this.$t(
            `rateDrying.qualityProgram.${ratingOption}`
          ).toString()
        )
      });
    }

    return val;
  }
}
